// extracted by mini-css-extract-plugin
export default {"heading":"myStyles_heading__PbN-Y","subHeading":"myStyles_subHeading__xeEKu","textfeild":"myStyles_textfeild__E0Ujo"};